import React, { useEffect, useState } from 'react'
import './TaskRunning.css'
import { progress } from '../../variables/services';
import Loading from '../Project/Service/Loading/Loading';
import { fetch_task } from './funcs'

const loadingLogo = '/icons/spinning-dots.svg';
const successLogo = '/icons/success.svg';
const errorLogo = '/icons/error.svg';
const pendingLogo = '/icons/pending.svg';


function TaskRunning({ taskId, done, className="" }) {

    const [task, setTask] = useState({})
    // const [timeout, setOurTimeout] = useState()


    useEffect(() => {
        if (!taskId) return;

        const startTime = Date.now();
        let timeoutId;

        const poll = async () => {
            const timePassed = (Date.now() - startTime) / 1000 / 60 > 10;
            if (timePassed) return; // stop after 10m

            const data = await fetch_task(taskId, setTask);

            if (data && data.done === "False") {
                timeoutId = setTimeout(poll, 1000); // poll again
            }
            else if (data && data.done === "True") {
                done()
            }
        };

        poll(); // start polling

        return () => clearTimeout(timeoutId); // cleanup
    }, [taskId]);


    return (
        <div className={`task-running ${className}`}>
            {Object.keys(task).length === 0 && <h1><Loading/></h1>}
            {Object.keys(task).length > 0 && 
                <div className='steps'>
                    {task.steps.map(step => {
                        return(
                        <div className='step'>
                            <label>{step.description}</label>
                            <img
                                className="status-icon"
                                src={
                                    step.status === "in progress" ? loadingLogo :
                                    step.status === "success"      ? successLogo :
                                    step.status === "failed"       ? errorLogo :
                                    step.status === "pending"       ? pendingLogo :
                                    ""
                                }
                            />
                        </div>)
                    })}
                </div>
            }
        </div>
    )
    }

export default TaskRunning